import React, {useEffect, useState} from 'react';
import {executeQueryUtil} from "../../utils/gqlUtil";
import {getDashBoardsQuery} from "../../gql/dashBoardGql";
import useAuth from "../../hooks/useAuth";
import localStrings from "../../localStrings";
import PageWithTitle from "../../components/pages/pageWithTitle";
import {Alert, Box, Button, Stack, Typography} from "@mui/material";
import {customBoardsRoute, dashboardBaseRoute, dashboardListRoute, dashboardRoutes} from "../../routes/dashboard";
import {useNavigate} from "react-router";

function NoDashboardForMobile() {
    const navigate = useNavigate();
    const {
        userInDb,

    } = useAuth();

    const [dashBoards, setDashBoards] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!userInDb) {
            return;
        }
        async function setItemSourceAsync() {
            let result = await executeQueryUtil(getDashBoardsQuery(userInDb.id));
            setDashBoards(result?.data?.getDashBoards || []);
        }
        setItemSourceAsync();
    }, [userInDb]);

    return (
        <PageWithTitle title={localStrings.myDashboards}>
            <Box sx={{ px: 2, mt: 3}}>

                <Stack sx={{width: '100%', marginTop: 5}} spacing={2}>
                    <Alert severity="warning">
                        <Typography variant="body1" sx={{ mb: 2 }}>
                            {localStrings.noDashBoradYet}
                        </Typography>

                    </Alert>
                </Stack>


                <Button
                    sx={{ mt: 3 }}
                    variant="outlined"
                    onClick={() => navigate(`/${dashboardBaseRoute}/${dashboardListRoute}`)}
                    fullWidth
                >
                    {localStrings.manageMyBoards}
                </Button>
            </Box>
        </PageWithTitle>
    )
}

export default NoDashboardForMobile